import styled from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';

export const RowText = styled(Text).attrs({
  color: 'primaryText',
  size: 'normal',
})`
  display: inline-flex;
  flex: 1 1 auto;
`;

export const ScrollableContainer = styled(Box).attrs({
  px: 16,
  py: '10px',
})`
  border: ${p => `1px solid ${p.theme.colors.heavyLineOutline}`};
  border-radius: 5px;
  overflow: scroll;
  max-height: 400px;
`;

export const SectionTitle = styled(Text).attrs({
  size: 'small',
  fontWeight: 'bold',
  color: 'secondaryText',
  my: 10,
})``;
